import { apiClient } from './client';

export interface CasinoBalance {
  found: boolean;
  balance: number;
  currency: string;
}

export interface CasinoOpResult {
  success: boolean;
  amount?: number;
  balanceBefore?: number;
  balanceAfter?: number;
  message?: string;
}

export const casinoApi = {
  getBalance: async (clientId: string): Promise<CasinoBalance> => {
    const { data } = await apiClient.get<CasinoBalance>('/chat/casino/balance', { params: { clientId } });
    return data;
  },
  deposit: async (clientId: string, amount: number): Promise<CasinoOpResult> => {
    const { data } = await apiClient.post<CasinoOpResult>('/chat/casino/deposit', { clientId, amount });
    return data;
  },
  withdraw: async (clientId: string, amount: number): Promise<CasinoOpResult> => {
    const { data } = await apiClient.post<CasinoOpResult>('/chat/casino/withdraw', { clientId, amount });
    return data;
  },
  register: async (clientId: string): Promise<{ ok: boolean; created?: boolean; linked?: boolean; casinoExternalId?: string; error?: string }> => {
    const { data } = await apiClient.post('/chat/casino/register', { clientId });
    return data;
  },
};
